module.exports = ".list-container {\n    max-height: 300px;\n    overflow-y: auto;\n}\n\n.list-group-item {\n    cursor: pointer;\n}\n\n.dimmed {\n    opacity: 0.5;\n}\n\n.item-group {\n    background: #f5f5f5;\n    cursor: default;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/phoenix2/common/components/happy-list/happy-list.component.css
// module id = ./src/app/phoenix2/common/components/happy-list/happy-list.component.css
// module chunks = main